module.exports = __webpack_public_path__ + "img/link-simple.c8aeac9f.svg";